import * as e from "react";
import { forwardRef as o } from "react";
const t = o(function(l, C) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: C,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...l
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M10.5064 19.5393L17.3524 17.6875C18.0229 17.5062 18.4167 16.8261 18.2316 16.17L15.1324 5.18892L19.9285 6.06016C20.6099 6.15771 21.0845 6.80008 20.9874 7.49398L19.2599 19.9087C19.1628 20.6026 18.5322 21.0857 17.8508 20.9873L10.3845 19.6188L10.5064 19.5393Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M7.91257 19.5207L16.592 17.1731C17.2625 16.9918 17.6563 16.3117 17.4712 15.6555L14.1549 3.90525C13.9698 3.24908 13.2757 2.86348 12.6043 3.04478L3.9249 5.39244C3.25439 5.57374 2.86061 6.25383 3.04571 6.91L6.36196 18.6603C6.54705 19.3164 7.24115 19.702 7.91257 19.5207ZM11.9674 11.9654L11.0093 10.6217L12.0182 9.31308L10.4177 9.79071L9.46048 8.44525L9.42963 10.0852L7.8273 10.5628L9.40876 11.0984L9.37791 12.7375L10.3859 11.4297L11.9674 11.9654ZM8.88703 6.59959C8.88703 6.59959 9.84698 7.08459 11.3622 7.87604C12.1606 8.29385 14.0007 9.37243 14.4607 10.8532C14.7674 11.8406 14.1985 12.8843 13.1914 13.1843C12.5299 13.3821 12.0472 13.1732 11.3667 12.7876C11.3667 12.7876 11.2588 12.7435 11.2016 12.7609C11.1072 12.7885 11.041 12.8797 11.0764 12.957C11.3123 13.4686 12.0245 14.6889 13.3683 14.7736L9.80887 15.8347C10.8768 15.0322 10.7752 13.6288 10.6808 13.0748C10.6654 12.9919 10.5601 12.9524 10.4658 12.98C10.4068 12.9975 10.3442 13.0922 10.3442 13.0922C10.0293 13.9187 9.7136 14.2214 9.05307 14.4184C8.04504 14.7193 6.98076 14.1625 6.67408 13.1751C6.21407 11.6943 7.13046 9.79392 7.5569 9.01075C8.36442 7.52725 8.88703 6.59959 8.88703 6.59959Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  t as PokerFill
};
